<div class="container">
  <h3>Twoja przeglądarka <span *ngIf="!browserCompatible">nie </span>jest wspierana.</h3>
  <div *ngIf="browserOutdated">
    <p>Zaktualizuj przeglądarkę do najnowszej wersji.</p>
  </div>

  <p>
    Listę wspieranych przeglądarek znajdziesz w <a href="{{rulesUrl}}" target="_blank">Regulaminie Portalu</a> .
  </p>
</div>
